import { SVGProps, Ref, forwardRef } from 'react';

export const UserCircleFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.334 16C1.334 8.667 5 1.333 16 1.333S30.667 8.667 30.667 16c0 4.846-1.601 9.692-5.862 12.422C24.635 22.116 20.318 20 16 20s-8.635 2.116-8.805 8.422C2.935 25.692 1.334 20.846 1.334 16M22.41 29.615c-1.787.672-3.91 1.052-6.41 1.052-2.503 0-4.625-.38-6.411-1.052v-.805c0-2.726.88-4.198 1.89-5.039 1.085-.905 2.674-1.371 4.52-1.371s3.435.466 4.52 1.371c1.01.84 1.89 2.313 1.89 5.04zm-9.344-16.948c0-.977.249-1.697.61-2.13.298-.357.9-.804 2.323-.804s2.026.447 2.323.803c.362.434.61 1.154.61 2.13 0 .977-.248 1.697-.61 2.13-.297.358-.9.804-2.323.804s-2.025-.446-2.323-.803c-.361-.434-.61-1.154-.61-2.13m-2.4 0C10.667 10 12 7.333 16 7.333s5.334 2.667 5.334 5.334S20 18 16 18s-5.333-2.667-5.333-5.333"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserCircleFilledSize32Glyph.displayName = 'UserCircleFilledSize32Glyph';
